import keyService, * as chord from "data/key"
import { CloseIcon } from 'images/icons/general'
import React, { FC, useEffect } from 'react'
import { Svg_s } from 'styles/app-styles'
import { PopoverContent_s, PopoverTitle_s, Popover_s } from './popover-styles'

interface Props {
  children: any,
  left?: number,
  position?: string,
  show: boolean,
  target: string,
  title: string,
  toggleShow: any,
  top?: number,
  width: number,
  headerButton?: Function,
}

const Popover: FC<Props> = (props) => {
  const popoverIcon = document.getElementById(props.target);
  const iconPosition = popoverIcon && popoverIcon.getBoundingClientRect();
  const bodyWidth = document.body.getBoundingClientRect().width;
  const popoverWidth = Number(props.width);
  const top = props.top ?? (iconPosition && iconPosition.bottom);
  const left = props.left ?? (iconPosition && iconPosition.left + popoverWidth > bodyWidth ? (bodyWidth - popoverWidth - 15) : iconPosition && iconPosition.left);

  useEffect(() => {
    keyService.stream().subscribe(k => {
      if (k.chord === chord.ESC) props.toggleShow(false)
    })
  }, [])

  return popoverIcon ? (
    <Popover_s
      left={props.left || left}
      top={top}
      iconPos={iconPosition!.left}
      position={props.position}
      show={props.show}
      width={props.width}
    >
      <PopoverTitle_s>
        <span>
          {props.title}
          {props.headerButton ? <props.headerButton /> : null}
        </span>
        <a onClick={()=>props.toggleShow(false)}><Svg_s src={CloseIcon} /></a>
      </PopoverTitle_s>
      <PopoverContent_s>
        { props.children }
      </PopoverContent_s>
    </Popover_s>
  ) : null
}

export default Popover
